import loadingReducer from './reducers'

export { default as loadingSelectors } from './selectors'
export { default as loadingOperations } from './operations'
export { default as loadingTypes } from './types'

export default loadingReducer
